import { User } from "../../../../auth/types";
import { httpWebApi } from "../../../../../core/http/httpThunks";
import { WeightedPricesReportFilter } from "../types";

export const getWeightedPriceReport = (
  user: User,
  filter: WeightedPricesReportFilter
) => {
  return httpWebApi<Blob>({
    method: "GET",
    responseType: "blob",
    timeout: 60 * 4 * 1000,
    url: "reporting/getweightedpricereport",
    params: {
      userid: user.userId,
      datefrom: filter.datefrom,
      dateto: filter.dateto,
      productid: filter.productid,
    },
  });
};

export default getWeightedPriceReport;
